window.ImageList = SiImageList.extend({
    getContent: function(data) {
        return Handlebars.templates["imagelist/imagelist"](data);
    },

    getData: function($xml, language) {
        var data = SiImageList.prototype.getData.call(this, $xml, language);
        data.buttonLabel = LanguageManager.getString("got_it");
        return data;
    }
});
